import { Status, Wrapper } from "@googlemaps/react-wrapper";
import { Stack } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Map from './Map';
import Marker from './Marker';
import { JournalEntry } from './models/JournalEntry';
import { Ride } from './models/Ride';
import { TripConfig } from './TripConfig';

function Home() {
    const [lastJournalEntry, setLastJournalEntry] = useState<JournalEntry | null>(null);
    const [rides, setRides] = useState<Ride[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
      Promise.all([
        fetch('/api/journal-entries.json').then(res => res.json()),
        fetch('/api/rides.json').then(res => res.json())
      ])
        .then(([journalEntries, ridesData]) => {
          // Get the last journal entry (they're sorted by date)
          if (journalEntries.length > 0) {
            setLastJournalEntry(journalEntries[journalEntries.length - 1]);
          }
          setRides(ridesData);
          setLoading(false);
        })
        .catch(err => {
          console.error('Failed to load data:', err);
          setLoading(false);
        });
    }, []);
    
    const render = (status: Status) => {
        return <h1>{status}</h1>;
      };

    return (
    <div style={{ display: "flex", height: "100%" }}>
    { loading ?
        <div></div>
        :
      <div className='container'>
        <div>
          <Stack>
            <div><b>{lastJournalEntry?.endDate}. {lastJournalEntry?.endLocation}</b></div>
            <div style={{maxWidth:"750px"}}>{lastJournalEntry?.summary}</div>
            <Link
              style={{ display: "block", margin: "1rem 0" }}
              to={`/journal/${lastJournalEntry?.id}`}
              key={lastJournalEntry?.id}
            >
              Read More in the Last Journal Entry
            </Link>
            <div style={{textAlign: "center"}}><b>{lastJournalEntry?.imageCaption}</b></div>
            <img style={{maxWidth: "100%", height:"auto"}} src={`/img/${lastJournalEntry?.image}`}/>
          </Stack>
        </div>
        <div>
          <Stack>
            <div style={{textAlign: "center"}}><b>Route</b></div>
            <Wrapper apiKey={TripConfig.googleMapsApiKey} render={render}>
              <Map
                mapTypeId={'terrain'}
                center={TripConfig.mapCenter}
                zoom={TripConfig.mapZoom}
                style={{width: TripConfig.mapWidth, height: TripConfig.mapHeight}}
              >
                {rides.map(ride =>
                  <Marker
                    key={ride.rideId}
                    icon={{path:"M 0 0 L 6 0 L 6 6 L 0 6 z",
                    fillColor: "#656398",
                    fillOpacity: 1,
                    strokeColor: '#656398',
                    strokeWeight: 1,
                    scale: 1,}}
                    position={ride.startCoordinates}
                  />
                 )
                }
              </Map>
            </Wrapper>
          </Stack>
        </div>
      </div>
    }
    </div>
  );
}
export default Home;